<ngx-spinner  size = "default" color = "#007bff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" > Loading </p></ngx-spinner>
   <router-outlet></router-outlet>
 
  

